import { Injectable } from '@angular/core';
import { catchError , retry } from 'rxjs/internal/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { HttpParams } from '@angular/common/http';


@Injectable({
	providedIn: 'root'
})

export class ReportsService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';
	color: any = 'blue';
	constructor(private http: HttpClient,private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.user.subscribe( (result: any) => {
			this.user = result;
		});
	}
	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public getReports() {
		const method = 'reports';
		return this.http.get(this.setEndPoint(method));
	}

	public getReport(file, type) {
		const method = 'reports/report&file=' + file + '&type=' + type;
		return this.http.get(this.setEndPoint(method));
	}

	public getDaySales() {
		const method = 'reports/days';
		return this.http.get(this.setEndPoint(method));
	}

	public getDayBrands(date: string) {
		const method = 'reports/daybrands&date=' + date;
		return this.http.get(this.setEndPoint(method));
	}

	public getDayBrandCustomers(date: string, brandId: number | null) {
		const bid = brandId !== null ? brandId : 0;
		const method = 'reports/daybrandcustomers&date=' + date + '&brand_id=' + bid;
		return this.http.get(this.setEndPoint(method));
	}

	public getDayCustomerInvoices(date: string, debtorno: string, brandId: number | null) {
		const bid = brandId !== null ? brandId : 0;
		const method = 'reports/daycustomerinvoices&date=' + date + '&debtorno=' + debtorno + '&brand_id=' + bid;
		return this.http.get(this.setEndPoint(method));
	}

	public getInvoiceLineItems(transno: string) {
		const method = 'reports/invoicelineitems&transno=' + transno;
		return this.http.get(this.setEndPoint(method));
	}

	public getDaySalesmen(date: string) {
		const method = 'reports/daysalesmen&date=' + date;
		return this.http.get(this.setEndPoint(method));
	}

	public getDaySalesmanCustomers(date: string, salesmancode: string) {
		const method = 'reports/daysalesmancustomers&date=' + date + '&salesmancode=' + encodeURIComponent(salesmancode);
		return this.http.get(this.setEndPoint(method));
	}

	public getDaySalesmanInvoices(date: string, salesmancode: string, debtorno: string) {
		const method = 'reports/daysalesmaninvoices&date=' + date + '&salesmancode=' + encodeURIComponent(salesmancode) + '&debtorno=' + debtorno;
		return this.http.get(this.setEndPoint(method));
	}

	public getHourSales() {
		const method = 'reports/day';
		return this.http.get(this.setEndPoint(method));
	}

	public getSpiffConfig() {
		const method = 'reports/getspiffconfigs';
		return this.http.get(this.setEndPoint(method));
	}

	public runSpiff(data) {
		const method = 'reports/runspiff';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public removeSpiffConfig(data){
		const method = 'reports/removespiff' + '&id=' + data ;
		return this.http.get(this.setEndPoint(method));
	}

	public setSpiffActive(data){
		const method = 'reports/setspiffactive';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public saveSpiffConfig(data){
		const method = 'reports/savespiff';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public updateSpiffConfig(data){
		const method = 'reports/updatespiff';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public loadGapCustomers() {
		const method = 'reports/getgapcustomers';
		return this.http.get(this.setEndPoint(method));
	}

	public loadGapBrands() {
		const method = 'reports/getgapbrands';
		return this.http.get(this.setEndPoint(method));
	}

	public buildGapBrands() {
		const method = 'reports/buildgapbrands';
		return this.http.get(this.setEndPoint(method));
	}

	public loadGapBrandCategories(mfg) {
		const method = 'reports/getgapbrandcategories&mfg=' +mfg;
		return this.http.get(this.setEndPoint(method));
	}

	public loadGapBrandTopProds(mfg) {
		const method = 'reports/getgapbrandtopprods&mfg=' +mfg;
		return this.http.get(this.setEndPoint(method));
	}


	public runReport(variables) {
		const params = new HttpParams();


		return this.http.get(this.runReportURL() + variables);
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}


	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private setTelegramEndPoint(method: any){
		return this.getBaseUrl() +'?route=' + method + this.getApiKey();
	}

	private getBaseUrl(){
		return this.config.apiServer.baseUrl;
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}


	public getTelegramReports(){
		const method = 'telegram/report/list';
		return this.http.get(this.setTelegramEndPoint(method))
	}

	public runTelegramReport(data){
		const method = 'telegram/report/' + data;
		return this.http.get(this.setTelegramEndPoint(method));
	}

	public getReportData(file, type) {
		const method = 'reports/report&file=' + file + '&type=' + type;
		return this.http.get(this.getApi() + method);
	}

	public getJpms(data: any) {
		const method = 'reports/jpms';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public getPmm(data: any) {
		const method = 'reports/pmm';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public getJpmsPerks(data: any) {
		const method = 'reports/jpms/perks';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}


	public getCustomerItemProdlineSales(data: any) {
		const method = 'reports/customeritemprodlinesales';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public getCRPT(data: any) {
		const method = 'reports/crpt';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCRPTDrill(data: any) {
		const method = 'reports/crptdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCSRPT(data: any) {
		const method = 'reports/csrpt';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCSRPTDrill(data: any) {
		const method = 'reports/csrptdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getBrandSales(data: any) {
		const method = 'reports/brandreport';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCustomerTypeSales(data: any) {
		const method = 'reports/customertypesales';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('customertypesales', data))
		);
	}
	public getSRPT(data: any) {
		const method = 'reports/srpt';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getSRPTDrill(data: any) {
		const method = 'reports/srptdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getSPSLS(data: any) {
		const method = 'reports/spsls';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getSPSLSDrill(data: any) {
		const method = 'reports/spslsdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public getVRPT(data: any) {
		const method = 'reports/vrpt';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getVRPTDrill(data: any) {
		const method = 'reports/vrptdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCPSLS(data: any) {
		const method = 'reports/cpsls';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCPSLSDrill(data: any) {
		const method = 'reports/cpslsdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCPDET(data: any) {
		const method = 'reports/cpdet';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCPDETDrill(data: any) {
		const method = 'reports/cpdetdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCVSLS(data: any) {
		const method = 'reports/cvsls';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getCVSLSDrill(data: any) {
		const method = 'reports/cvslsdrill';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getBranches(){
		const method = 'reports/branches';
		return this.http.get(this.setEndPoint(method));
	}

	public getSalesPeople(){
		const method = 'reports/salespeople';
		return this.http.get(this.setEndPoint(method));
	}

	public getSalesDashboard(data: any) {
		const method = 'reports/salesdashboard';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('salesdashboard', data))
		);
	}
	public getSalonCentricVendors(){
		const method = 'reports/saloncentric/vendors';
		return this.http.get(this.setEndPoint(method));
	}
	public getSalonCentricReport(data: any){
		const method = 'reports/saloncentric/report';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}
	public getNonTurningInventory(data: any) {
		const method = 'reports/nonturninginventory';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('nonturninginventory', data))
		);
	}

	public getCommissionedSalesMeta() {
		const method = 'reports/commissioned_sales_meta';
		return this.http.get(this.setEndPoint(method));
	}

	public getCommissionedSales(data: any) {
		const method = 'reports/commissioned_sales';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('commissioned_sales', data))
		);
	}

	public getNitmsReport(data: any) {
		let method = 'reports/new_items_report';
		if (data.from) {method += '&from=' + encodeURIComponent(data.from);}
		if (data.to) {method += '&to=' + encodeURIComponent(data.to);}
		if (data.category?.length) {method += '&category=' + encodeURIComponent(data.category);}
		if (data.brand?.length) {method += '&brand=' + encodeURIComponent(data.brand);}
		if (data.salesman) {method += '&salesman=' + encodeURIComponent(data.salesman);}
		return this.http.get(this.setEndPoint(method));
	}

	public getCustomerCreditCardsMeta() {
		const method = 'reports/customer_credit_cards_meta';
		return this.http.get(this.setEndPoint(method));
	}

	public getCustomerCreditCards(data: any) {
		const method = 'reports/customer_credit_cards';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('customer_credit_cards', data))
		);
	}

	public getStrptSmMeta() {
		const method = 'reports/strpt_sm_meta';
		return this.http.get(this.setEndPoint(method));
	}

	public getStrptSm(data: any) {
		const method = 'reports/strpt_sm';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('strpt_sm', data))
		);
	}

	public getStrptSmStats(data: any) {
		const method = 'reports/strpt_sm_stats';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('strpt_sm_stats', data))
		);
	}

	public getSalesRouteMeta() {
		const method = 'reports/sales_route_meta';
		return this.http.get(this.setEndPoint(method));
	}

	public postSalesRouteAccounts(data: any) {
		const method = 'reports/sales_route_accounts';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_accounts', data))
		);
	}

	public postSalesRouteCustomerDetail(data: any) {
		const method = 'reports/sales_route_customer_detail';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_customer_detail', data))
		);
	}

	public postSalesRouteAiEnrich(data: any) {
		const method = 'reports/sales_route_ai_enrich';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_ai_enrich', data))
		);
	}

	public postSalesRouteOptimize(data: any) {
		const method = 'reports/sales_route_optimize';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_optimize', data))
		);
	}

	public getSalesRouteTemplates(zone?: string) {
		let method = 'reports/sales_route_templates';
		if (zone) { method += '&zone=' + encodeURIComponent(zone); }
		return this.http.get(this.setEndPoint(method));
	}

	public getSalesRouteTemplateStops(templateId: number) {
		const method = 'reports/sales_route_template_stops&id=' + encodeURIComponent(String(templateId));
		return this.http.get(this.setEndPoint(method));
	}

	public postSalesRouteApplyTemplate(data: any) {
		const method = 'reports/sales_route_apply_template';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_apply_template', data))
		);
	}

	public getSalesRouteList(salesman: string) {
		const method = 'reports/sales_route_list&salesman=' + encodeURIComponent(salesman);
		return this.http.get(this.setEndPoint(method));
	}

	public getSalesRouteWeek(salesman: string, weekStart: string) {
		const method = 'reports/sales_route_get&salesman=' + encodeURIComponent(salesman) + '&week_start=' + encodeURIComponent(weekStart);
		return this.http.get(this.setEndPoint(method));
	}

	public postSalesRouteSave(data: any) {
		const method = 'reports/sales_route_save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_save', data))
		);
	}

	public postSalesRouteGeocode(data: any) {
		const method = 'reports/sales_route_geocode';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_geocode', data))
		);
	}

	public postSalesRouteBulkGeocode(data: any) {
		const method = 'reports/sales_route_bulk_geocode';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_bulk_geocode', data))
		);
	}

	public postSalesRouteCheckin(data: any) {
		const method = 'reports/sales_route_checkin';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_checkin', data))
		);
	}

	public postSalesRouteAiplan(data: any) {
		const method = 'reports/sales_route_aiplan';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_aiplan', data))
		);
	}

	public getSalesRouteTerritoryBranches(territoryId: number, q?: string) {
		let method = 'reports/sales_route_territory_branches&id=' + encodeURIComponent(String(territoryId));
		if (q) { method += '&q=' + encodeURIComponent(q); }
		return this.http.get(this.setEndPoint(method));
	}

	public postSalesRouteAssignTerritory(data: any) {
		const method = 'reports/sales_route_assign_territory';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_assign_territory', data))
		);
	}

	public postSalesRouteSaveTemplate(data: any) {
		const method = 'reports/sales_route_save_template';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_save_template', data))
		);
	}

	public postSalesRouteStopStatus(data: any) {
		const method = 'reports/sales_route_stop_status';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_stop_status', data))
		);
	}

	public postSalesRouteNearby(data: any) {
		const method = 'reports/sales_route_nearby';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_nearby', data))
		);
	}

	public postSalesRouteProspects(data: any) {
		const method = 'reports/sales_route_prospects';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_prospects', data))
		);
	}

	public postSalesRouteSaveCoords(data: any) {
		const method = 'reports/sales_route_save_coords';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_save_coords', data))
		);
	}

	public getSalesRouteNotes(target: { debtorno?: string; branchcode?: string; prospect_key?: string }) {
		let method = 'reports/sales_route_notes';
		if (target.prospect_key) {
			method += '&prospect_key=' + encodeURIComponent(target.prospect_key);
		} else {
			method += '&debtorno=' + encodeURIComponent(target.debtorno || '') + '&branchcode=' + encodeURIComponent(target.branchcode || '');
		}
		return this.http.get(this.setEndPoint(method));
	}

	public postSalesRouteNoteSave(data: any) {
		const method = 'reports/sales_route_note_save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_note_save', data))
		);
	}

	public postSalesRouteFollowupComplete(data: any) {
		const method = 'reports/sales_route_followup_complete';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('sales_route_followup_complete', data))
		);
	}

	// Recurring Replenishment — reads the nightly recurring_candidates snapshot.
	// See docs/RECURRING_CANDIDATES_CRON.md for how that snapshot is built.
	public getRecurringDue(params: any) {
		return this.http.get(this.setEndPoint('reports/aa_recurring/due' + this.recurringQuery(params)));
	}

	public getRecurringCustomers(params: any) {
		return this.http.get(this.setEndPoint('reports/aa_recurring/customers' + this.recurringQuery(params)));
	}

	public getRecurringItems(params: any) {
		return this.http.get(this.setEndPoint('reports/aa_recurring/items' + this.recurringQuery(params)));
	}

	public getRecurringCustomer(debtorno: string) {
		return this.http.get(this.setEndPoint('reports/aa_recurring/customer&debtorno=' + encodeURIComponent(debtorno)));
	}

	public getRecurringFilters() {
		return this.http.get(this.setEndPoint('reports/aa_recurring/filters'));
	}

	/** The orders/invoices behind one cycle — the "why" drill-down. code is a lineid or a stkcode depending on level. */
	public getRecurringHistory(debtorno: string, code: string, level = 'line') {
		return this.http.get(this.setEndPoint('reports/aa_recurring/history'
			+ '&debtorno=' + encodeURIComponent(debtorno)
			+ '&stkcode=' + encodeURIComponent(code)
			+ '&level=' + encodeURIComponent(level)));
	}

	/** Which SKUs of a line this customer actually buys — expands one line row. */
	public getRecurringSkus(debtorno: string, lineid: string) {
		return this.http.get(this.setEndPoint('reports/aa_recurring/skus'
			+ '&debtorno=' + encodeURIComponent(debtorno)
			+ '&lineid=' + encodeURIComponent(lineid)));
	}

	// Promo / Intro Performance — deal header SKUs (stockmaster.mbflag = 'C') and
	// the component lines they entitle. See apir/reports/promo_intro.php.
	public getPromoIntroPromos(params: any) {
		return this.http.get(this.setEndPoint('reports/promo_intro/promos' + this.queryString(params)));
	}

	public getPromoIntroCustomers(params: any) {
		return this.http.get(this.setEndPoint('reports/promo_intro/customers' + this.queryString(params)));
	}

	/** What shipped inside one deal, per component SKU — the "why is this a loss" drill. */
	public getPromoIntroComponents(stockid: string, params: any) {
		return this.http.get(this.setEndPoint('reports/promo_intro/components'
			+ '&stockid=' + encodeURIComponent(stockid) + this.queryString(params)));
	}

	public getPromoIntroOrders(stockid: string, params: any) {
		return this.http.get(this.setEndPoint('reports/promo_intro/orders'
			+ '&stockid=' + encodeURIComponent(stockid) + this.queryString(params)));
	}

	/** Configuration health — no date range, reads promos / mixandmatch directly. */
	public getPromoIntroSetup() {
		return this.http.get(this.setEndPoint('reports/promo_intro/setup'));
	}

	public getPromoIntroFilters() {
		return this.http.get(this.setEndPoint('reports/promo_intro/filters'));
	}

	// Brand Sales Ranked by Salesperson — both pick lists and data are gated server-side.
	public getBrandSalesRankingMeta() {
		return this.http.get(this.setEndPoint('reports/brand_sales/meta'));
	}

	public getBrandSalesRanking(params: {
		from: string; to: string; brands: any[]; plines: any[]; categories: any[];
		salespeople: any[]; groupby: string; path: string;
	}) {
		// setEndPoint already appended a query string, so every param joins with '&'.
		let q = '&from=' + encodeURIComponent(params.from) + '&to=' + encodeURIComponent(params.to);
		if (params.brands?.length)      { q += '&brands=' + encodeURIComponent(params.brands.join(',')); }
		if (params.plines?.length)      { q += '&plines=' + encodeURIComponent(params.plines.join(',')); }
		if (params.categories?.length)  { q += '&categories=' + encodeURIComponent(params.categories.join(',')); }
		if (params.salespeople?.length) { q += '&salespeople=' + encodeURIComponent(params.salespeople.join(',')); }
		if (params.groupby)             { q += '&groupby=' + encodeURIComponent(params.groupby); }
		if (params.path)                { q += '&path=' + encodeURIComponent(params.path); }

		return this.http.get(this.setEndPoint('reports/brand_sales/ranking' + q));
	}

	/** setEndPoint already appends a query string, so every param joins with '&'. */
	private recurringQuery(params: any): string {
		return this.queryString(params);
	}

	private queryString(params: any): string {
		let qs = '';
		for (const k of Object.keys(params || {})) {
			const v = params[k];
			if (v === '' || v === null || v === undefined) { continue; }
			qs += '&' + k + '=' + encodeURIComponent(v);
		}
		return qs;
	}

	private runReportURL() {
		return this.config.apiServer.reportEndpoint;
	}
	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return throwError(() => error);
		};
	}
}
